const VISITOR_ID_COOKIE = 'audicus_vid';
const VISITOR_ID_MAX_AGE_SECONDS = 60 * 60 * 24 * 400;
const VISITOR_ID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

let published = false;

export function readVisitorId(
  cookieHeader: string | null | undefined,
): string | null {
  if (!cookieHeader) {
    return null;
  }

  const parts = cookieHeader.split(';');

  for (let index = 0; index < parts.length; index += 1) {
    const trimmed = parts[index].trim();
    const separator = trimmed.indexOf('=');

    if (
      separator === -1 ||
      trimmed.slice(0, separator) !== VISITOR_ID_COOKIE
    ) {
      continue;
    }

    let value = trimmed.slice(separator + 1);

    try {
      value = decodeURIComponent(value);
    } catch {
      return null;
    }

    return VISITOR_ID_PATTERN.test(value) ? value : null;
  }

  return null;
}

/**
 * Same audicus_vid cookie as www.audicus.com. privacy-bootstrap.js sets it
 * before the app loads. This covers a page where that script did not run.
 */
export function ensureVisitorId(): string | null {
  if (typeof document === 'undefined') {
    return null;
  }

  const existing = readVisitorId(document.cookie);
  const visitorId = existing ?? crypto.randomUUID();

  if (!existing) {
    const hostname = window.location.hostname;
    const onAudicus =
      hostname === 'audicus.com' || hostname.endsWith('.audicus.com');
    const parts = [
      `${VISITOR_ID_COOKIE}=${visitorId}`,
      'Path=/',
      `Max-Age=${VISITOR_ID_MAX_AGE_SECONDS}`,
      'SameSite=Lax',
    ];

    if (onAudicus) {
      parts.push('Secure', 'Domain=.audicus.com');
    }

    document.cookie = parts.join('; ');
  }

  if (!published) {
    published = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ visitor_id: visitorId });
  }

  return visitorId;
}
